import { render } from "./SuccessConfirmAppointmentView.vue?vue&type=template&id=b8bbbb3c&scoped=true"
const script = {}

import "./SuccessConfirmAppointmentView.vue?vue&type=style&index=0&id=b8bbbb3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8bbbb3c"]])

export default __exports__